import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { LoadingFull, LoadingOverlay } from '../../components/loading'
import axios from 'axios'
import { BookOverview } from '../../components/dashboard/soldBook/bookOverview'
import { ChoosePrice } from '../../components/dashboard/newBook/choosePrice'
import { ChooseCondition } from '../../components/dashboard/newBook/chooseCondition'
import { ChooseImages } from '../../components/dashboard/newBook/chooseImages'
import { BookDetails } from '../../components/dashboard/newBook/bookDetails'

const EditBook = () => {

  const { user } = useContext(UserContext)
  const token = localStorage.getItem('token')
  const [uOb, setUOB] = useState()
  const [data, setData] = useState()
  const [price, setPrice] = useState()
  const [formattedPrice, setFormattedPrice] = useState()
  const [condition, setCondition] = useState()
  const [desc, setDesc] = useState('')
  const [beforeImages, setBeforeImages] = useState([])
  const [images, setImages] = useState([])
  const [imageFiles, setImageFiles] = useState([])
  const [error_image, setError_Image] = useState('');
  const [error_condition, setError_Condition] = useState('');
  const [error_price, setError_Price] = useState('');
  const [succesMessage, setSuccesMessage] = useState('');
  const [load, setLoad] = useState(false);
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();

  async function loadImages(data) {
    setImageFiles(Array.from({ length: data.dbBook['images'] }))
    const existingImages = [];
    for (let i = 0; i < data.dbBook['images']; i++) {
      try {
        const imageUrl = `https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F${i}?alt=media`;

        const response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error(`Kunne ikke hente billede ${i}: ${response.statusText}`);
        }

        const blob = await response.blob();
        const filename = `${i}.jpg`;
        const file = new File([blob], filename, { type: blob.type });

        existingImages.push(file);
        setImages(prev => [...prev, `https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F${i}?alt=media`])
        setBeforeImages(prev => [...prev, `https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${data.dbBook['_id']}%2F${i}?alt=media`])
      } catch (error) {
          console.warn(error.message); // Logger fejlen, men stopper ikke loopen
          continue; // Går videre til næste billede
      }
    }
    setImageFiles(existingImages); // Opdater state med de billeder, der kunne hentes
    console.log("Billeder hentet færdig!");
  }
  
  const deleteBook = () => {
    setLoad(true)
    axios({
        method: 'post',
        url: '/api/deleteMyBook',
        data: {
            'dbId': data.dbBook['_id']
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
      setLoad(false)
      navigate('/dashboard/bøger')
    })
    .catch(error => {
      setLoad(false)
      console.log(error);
    });
  }

  useEffect(() => {
    axios({
      method: 'post',
      url: '/api/userOwnsBook',
      data: {
          'userId': user._id,
          'dbId': searchParams.get("book")
      },
      headers: {
          Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      setData(response.data)
      setPrice(response.data.dbBook.price)
      setCondition(response.data.dbBook.stand)
      setDesc(response.data.dbBook.desc)
      setFormattedPrice(String(response.data.dbBook.price/100).replace('.', ','))
      loadImages(response.data)
      setUOB(true)
    })
    .catch(error => {
      setUOB(false)
    });
  }, [])
  
  function getPrice(price) {
    let withoutMask = price.toString().replace(/[^\d,-]/g, '')
    withoutMask = withoutMask.replace(/,/g, '.')
    let asNumber = (Math.round(Number(withoutMask) * 100) / 100).toFixed(2)
    asNumber = asNumber.toString().replace(/\./g, '')
    setPrice(Number(asNumber))
    setError_Price('')
  }

  function scrollTo(id) {
    if (id === 'top') {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    } else {
      const element = document.getElementById(id);
      if (element) {
        const offset = 75; // Juster denne værdi til ønsket afstand (100-200px)
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      }
    }
  }

  const updateBook = () => {
    if (price !== data.dbBook['price'] || condition !== data.dbBook['stand'] || desc !== data.dbBook['desc'] || (beforeImages.length !== images.length || !beforeImages.every((value, index) => value === images[index]))) {
      if (images.length > 0) {
        if (price/100 >= 50) {
          if (condition === 1 || condition === 2 || condition === 3) {
            setSuccesMessage()
            var formData = new FormData()
            for (let i = 0; i < imageFiles.length; i++) {
              formData.append('bookImages[]', imageFiles[i])
            }
            formData.append('dbId', data.dbBook._id)
            formData.append('condition', condition)
            formData.append('desc', desc)
            formData.append('price', price)
            axios({
              method: 'post',
              url: '/api/editBook',
              data: formData,
              headers: {
                  Authorization: `Bearer ${token}`
              }
            })
            .then(response => {
              setData(response.data)
              navigate('/dashboard/bøger')
              setSuccesMessage("Ændringerne er gemt")
            })
            .catch(error => {
              setSuccesMessage('')
              setError_Price(error.response.data.error_price)
            });
          } else {
            setError_Condition('Vælg venligst en stand')
            scrollTo('setCondition')
          }
        } else {
          setError_Price("Mindste pris er 50 kr.")
          scrollTo('setPrice')
        }
      } else {
        setError_Image("Du skal mindst tilføjet ét billede")
        scrollTo('uploadImage')
      }
    }
  }

  if (uOb) {
    return (
      <div className="flex flex-col gap-y-10 md:w-[600px] lg:w-[700px] mx-auto">
        {load ?
          <div className="fixed h-lvh w-full z-20 top-0 left-0">
            <LoadingOverlay />
          </div>
        :
          ""}
        {(typeof succesMessage === 'undefined') ?
          <div className="fixed h-lvh w-full z-20 top-0 left-0">
            <LoadingOverlay />
          </div>
        :
          ""
        }
        <BookDetails book={data.apiBook} />
        <ChooseImages imageFiles={imageFiles} setImageFiles={setImageFiles} images={images} setImages={setImages} error={error_image} setError={setError_Image} scrollTo={scrollTo} />
        <ChooseCondition condition={condition} setCondition={setCondition} desc={desc} setDesc={setDesc} error={error_condition} setError={setError_Condition} />
        <ChoosePrice price={price} formattedPrice={formattedPrice} setPrice={getPrice} error={error_price} setError={setError_Price} />
        <div className="flex flex-col gap-4">
          {(succesMessage !== '' && typeof succesMessage !== 'undefined') ?
            <div className="text-center text-emerald-600">
              {succesMessage}
            </div>
          :
            ""}
          <button onClick={updateBook} className={"w-full flex items-center gap-2 text-white bg-gradient-to-r from-emerald-500 to-emerald-800 transition-[] bg-size-200 bg-pos-0 inline-flex justify-center w-auto px-4 py-4 text-sm font-medium leading-5 transition-all duration-150 ease-in-out" + (price !== data.dbBook['price'] || condition !== data.dbBook['stand'] || desc !== data.dbBook['desc'] || (beforeImages.length !== images.length || !beforeImages.every((value, index) => value === images[index])) ? " hover:bg-pos-100" : " opacity-50")} disabled={!(price !== data.dbBook['price'] || condition !== data.dbBook['stand'] || desc !== data.dbBook['desc'] || (beforeImages.length !== images.length || !beforeImages.every((value, index) => value === images[index])))}>
              Gem ændringer
          </button>
          <button onClick={deleteBook} className="text-center items-center gap-2 transition-[] justify-center w-fit mx-auto my-4 text-sm font-medium leading-5 transition-all duration-150 ease-in-out">
              Slet bog
          </button>
        </div>
      </div>
    )
  } else if (typeof uOb === 'undefined') {
    return <LoadingFull />
  } else {
    return <Navigate to="/" />
  }

}

export default EditBook